










































import { Component, Vue, Prop } from 'vue-property-decorator';
import quotationServices from '@/services/quotation-services';

@Component
export default class FilterBox extends Vue {
    @Prop({ default: 'all' })
    private currentStatus!: string;

    private searchTerm: string = '';
    private counts: any = {
        'all': 0,
        'draft': 0,
        'cho-duyet': 0,
        'da-gui': 0,
        'kh-da-duyet': 0,
        'xnk-da-duyet': 0,
        'dang-van-chuyen': 0,
        'hoan-thanh': 0,
        'huy': 0,
    };

    private statusTabs = [
        { name: 'Tất cả', value: 'all', color: '#bdc3d1' },
        { name: 'Nháp', value: 'draft', color: '#7a8498' },
        { name: 'Chờ duyệt', value: 'cho-duyet', color: '#f39c12' },
        { name: 'Đã gửi KH', value: 'da-gui', color: '#2bbae4' },
        { name: 'KH đã duyệt', value: 'kh-da-duyet', color: '#27ae60' },
        { name: 'XNK đã duyệt', value: 'xnk-da-duyet', color: '#2980b9' },
        { name: 'Đang vận chuyển', value: 'dang-van-chuyen', color: '#f7819f' },
        { name: 'Hoàn thành', value: 'hoan-thanh', color: '#7a8498' },
        { name: 'Đã hủy', value: 'huy', color: 'black' },
    ];

    get selectedStatusObj() {
        return this.statusTabs.find(s => s.value === this.currentStatus) || this.statusTabs[0];
    }

    private async created() {
        await this.loadCounts();
    }

    public async loadCounts() {
        try {
            const res: any = await quotationServices.getStatusCounts();
            if (res && res.data && res.data.status === 200) {
                this.counts = { ...this.counts, ...res.data.data };
            }
        } catch (e) {
            // silent
        }
    }

    getTotalQuotation(status: string) {
        if (!this.counts || this.counts[status] === undefined) {
            return 0;
        }
        const total = this.counts[status];
        if (total < 999) {
            return total.toLocaleString('en-US');
        }
        return (Math.floor(total / 1000)).toLocaleString('en-US') + 'K';
    }

    private onclickStatus(status: any) {
        const val = typeof status === 'string' ? status : status.value;
        this.$emit('changeStatus', val);
        this.$emit('eventFilterChange', {
            searchText: this.searchTerm,
            status: val
        });
    }

    private onTextSearchChange() {
        this.$emit('search', this.searchTerm.trim());
        this.$emit('eventFilterChange', {
            searchText: this.searchTerm.trim(),
            status: this.currentStatus
        });
    }
}
